var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "bx_basket" } },
    [
      _c("notifications", {
        attrs: {
          group: _vm.groupNotify,
          closeOnClick: false,
          width: 600,
          max: 5,
          "animation-name": "v-fade-left",
          position: "top left",
        },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function (props) {
              return [
                _c("div", { staticClass: "custom-template" }, [
                  _c("div", { staticClass: "custom-template-icon" }, [
                    _c(
                      "a",
                      {
                        staticClass: "link",
                        attrs: { target: "_blank", href: props.item.data.url },
                      },
                      [
                        _c("img", {
                          attrs: { src: props.item.data.imageSmall },
                        }),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "custom-template-content" }, [
                    _c("div", { staticClass: "custom-template-title" }, [
                      _vm._v(
                        "\n          " + _vm._s(props.item.title) + "\n        "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "custom-template-text",
                      domProps: { innerHTML: _vm._s(props.item.text) },
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "custom-template-action" }, [
                      _c(
                        "button",
                        {
                          staticClass:
                            "button button_theme_primary_blue button_size_xs",
                          on: {
                            click: function ($event) {
                              return _vm.addToCart(
                                props.item.data.id,
                                props.item.data.productId,
                                props.item.data.count
                              )
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n              Добавить в корзину\n          "
                          ),
                        ]
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "custom-template-close",
                      on: {
                        click: function ($event) {
                          return _vm.close(
                            props.item.data.id,
                            props.item.data.productId
                          )
                        },
                      },
                    },
                    [_c("i", { staticClass: "icon icon-close" })]
                  ),
                ]),
              ]
            },
          },
        ]),
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "header__profile-mini profile-mini dropdown-label" },
        [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "dropdown-label__container" }, [
            _c(
              "div",
              { staticClass: "profile-mini__contant" },
              [
                _vm.user
                  ? [
                      _c(
                        "a",
                        {
                          staticClass:
                            "profile-mini__link profile-mini__link_profile",
                          attrs: { href: "/personal/" },
                        },
                        [_vm._v(_vm._s(_vm.user.name))]
                      ),
                      _c("br"),
                      _vm._v(" "),
                      _vm.user.bonus > 0
                        ? _c(
                            "a",
                            {
                              staticClass:
                                "profile-mini__link profile-mini__link_profile",
                              attrs: { href: "/personal/bonus_history/" },
                            },
                            [_vm._v("Бонусов: " + _vm._s(_vm.user.bonus))]
                          )
                        : _vm._e(),
                      _vm.user.bonus > 0 ? _c("br") : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass:
                            "profile-mini__link profile-mini__link_logout",
                          attrs: { href: "?logout=yes" },
                        },
                        [_vm._v("Выйти")]
                      ),
                    ]
                  : [
                      _c(
                        "a",
                        {
                          attrs: {
                            href: "/auth/?register=yes&backurl=" + _vm.curPage,
                          },
                        },
                        [_vm._v("Регистрация")]
                      ),
                      _c("br"),
                      _vm._v(" "),
                      _c(
                        "a",
                        { attrs: { href: "/auth/?backurl=" + _vm.curPage } },
                        [_vm._v("Вход")]
                      ),
                    ],
              ],
              2
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _vm._m(1),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "header__cart-mini cart-mini dropdown-label dropdown-label_cart",
        },
        [
          _c("span", { staticClass: "cart-mini__header" }, [
            _c("a", {
              staticClass: "cart-mini__icon icon icon-basket-new",
              attrs: { href: "/personal/cart/" },
            }),
            _vm._v(" "),
            _c("span", { staticClass: "cart-mini__count basket_amount" }, [
              _vm._v(_vm._s(_vm.allBasketList.count)),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "cart-mini__summ-amount basket_price" }, [
              _vm._v(_vm._s(_vm._f("formatMoney")(_vm.allBasketList.price))),
            ]),
          ]),
          _vm._v(" "),
          "volume" in _vm.basket && _vm.allBasketList.count >= 0 && _vm.user
            ? _c(
                "span",
                { staticClass: "dropdown-label__container" },
                [
                  _c("SelectCart"),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "cart-mini__contant",
                      staticStyle: { "text-decoration": "none" },
                      attrs: { href: "/personal/cart/" },
                    },
                    [
                      _c("span", { staticClass: "cart-mini__box" }, [
                        _vm._v("\n                Сумма: "),
                        _c(
                          "span",
                          { staticClass: "cart-mini__value basket_price" },
                          [
                            _vm._v(
                              _vm._s(
                                _vm._f("formatMoney")(_vm.allBasketList.price)
                              )
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "cart-mini__box" }, [
                        _vm._v("\n                Объем: "),
                        _c(
                          "span",
                          { staticClass: "cart-mini__value basket_volume" },
                          [
                            _vm._v(
                              _vm._s(
                                _vm._f("formatVolume")(_vm.allBasketList.volume)
                              )
                            ),
                          ]
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "profile-mini__header" }, [
      _c(
        "a",
        {
          staticStyle: { "text-decoration": "none" },
          attrs: { href: "/personal/" },
        },
        [_c("span", { staticClass: "profile-mini__icon icon icon-profile" })]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "a",
      {
        staticClass: "favorite-mini dropdown-label",
        attrs: { href: "/personal/favorites/" },
      },
      [_c("span", { staticClass: "favorite-mini__icon icon icon-heart-full" })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }